import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IoHomeOutline,
  IoCubeOutline,
  IoBagOutline,
  IoMenu,
  IoDocumentTextOutline,
  IoCashOutline,
  IoHeadsetOutline,
  IoSettingsOutline,
  IoRefreshOutline,
  IoLogOutOutline,
  IoChevronForward,
} from "react-icons/io5";

const MenuItem = ({ icon: Icon, label, onClick }) => (
  <button
    onClick={onClick}
    className="flex w-full items-center justify-between rounded-lg px-4 py-3 transition-colors hover:bg-gray-100"
  >
    <div className="flex items-center gap-3">
      <Icon className="h-6 w-6 text-gray-700" />
      <span className="text-sm font-medium text-gray-900">{label}</span>
    </div>
    <IoChevronForward className="h-5 w-5 text-gray-400" />
  </button>
);

const MenuScreen = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
  });
  const [storeName, setStoreName] = useState("");
  const [featureMsg, setFeatureMsg] = useState("");
  const [showFeatureMsg, setShowFeatureMsg] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("vendorToken");
        const headers = { "Content-Type": "application/json" };
        if (token) headers["Authorization"] = `Bearer ${token}`;
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/vendors/profile`, {
          method: "GET",
          headers,
        });
        if (response.ok) {
          const data = await response.json();
          const profile = data?.data || {};
          setStoreName(profile.storeName || "");
          setUser({
            name: profile.name || "",
            email: profile.email || "",
          });
        } else {
          setStoreName("");
        }
      } catch {
        setStoreName("");
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    let fadeTimer;
    if (featureMsg) {
      setShowFeatureMsg(true);
      const timer = setTimeout(() => {
        setShowFeatureMsg(false);
        fadeTimer = setTimeout(() => setFeatureMsg(""), 500);
      }, 2000);
      return () => {
        clearTimeout(timer);
        clearTimeout(fadeTimer);
      };
    }
  }, [featureMsg]);

  const menuItems = [
    {
      icon: IoCubeOutline,
      label: "Add Product",
      action: () => navigate("/add-products"),
    },
    {
      icon: IoDocumentTextOutline,
      label: "Store Information",
      action: () => setFeatureMsg("Feature Coming Soon 😉"),
    },
    {
      icon: IoCashOutline,
      label: "Payment",
      action: () => setFeatureMsg("Feature Coming Soon 😉"),
    },
    {
      icon: IoHeadsetOutline,
      label: "Contact Us",
      action: () => navigate("/customer-care"),
    },
    {
      icon: IoSettingsOutline,
      label: "Settings",
      action: () => setFeatureMsg("Feature Coming Soon 😉"),
    },
    {
      icon: IoRefreshOutline,
      label: "Buyer Mode",
      action: () => setFeatureMsg("Feature Coming Soon 😉"),
    },
    {
      icon: IoLogOutOutline,
      label: "Logout",
      action: () => setFeatureMsg("Feature Coming Soon 😉"),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="w-full bg-[#19C463] px-2 py-2">
        <h1 className="text-xl font-semibold text-white">
          Welcome <span>{storeName || user.name}</span>!
        </h1>
        <p className="mt-1 text-sm text-white">
          <span>{user.email}</span>
        </p>
      </header>

      <main className="px-2 py-3 pb-24">
        {featureMsg && (
          <div
            className={`fixed left-1/2 top-4 z-50 w-[90vw] max-w-md -translate-x-1/2 rounded bg-yellow-100 px-4 py-2 text-center text-yellow-800 font-semibold shadow transition-opacity duration-500 ${showFeatureMsg ? 'opacity-100' : 'opacity-0'}`}
            style={{ pointerEvents: 'none' }}
          >
            {featureMsg}
          </div>
        )}
        <div className="rounded-lg bg-white p-2 shadow-sm">
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              icon={item.icon}
              label={item.label}
              onClick={item.action}
            />
          ))}
        </div>
      </main>

      <nav className="fixed bottom-0 left-0 right-0 flex items-center justify-around border-t border-gray-200 bg-white py-3">
        <button className="flex flex-col items-center gap-1" onClick={() => navigate("/vendor-home")}>
          <IoHomeOutline className="h-6 w-6 text-gray-500" />
          <span className="text-xs text-gray-500">Home</span>
        </button>
        <button className="flex flex-col items-center gap-1" onClick={() => navigate("/products")}>
          <IoCubeOutline className="h-6 w-6 text-gray-500" />
          <span className="text-xs text-gray-500">Product</span>
        </button>
        <button className="flex flex-col items-center gap-1" onClick={() => navigate("/vendor-orders")}>
          <IoBagOutline className="h-6 w-6 text-gray-500" />
          <span className="text-xs text-gray-500">Orders</span>
        </button>
        <button className="flex flex-col items-center gap-1" onClick={() => navigate("/menu")}>
          <IoMenu className="h-6 w-6 text-[#19C463]" />
          <span className="text-xs font-bold text-[#19C463]">Menu</span>
        </button>
      </nav>
    </div>
  );
};

export default MenuScreen;
